import { render, staticRenderFns } from "./ReadPaper.vue?vue&type=template&id=787562a7&scoped=true"
import script from "./ReadPaper.vue?vue&type=script&lang=js"
export * from "./ReadPaper.vue?vue&type=script&lang=js"
import style0 from "./ReadPaper.vue?vue&type=style&index=0&id=787562a7&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "787562a7",
  null
  
)

export default component.exports